import { Notification, NotificationLocationCode } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getProgramNotifications: (
  fetchContext: FetchContext,
  programId: number,
  locationCode: NotificationLocationCode,
  accessToken?: string,
) => Promise<Notification[]> = (fetchContext, programId, locationCode, accessToken) => {
  const params = new URLSearchParams();
  params.append('locationCode', locationCode);

  return fetch(`${fetchContext.baseUrl}/api/programs/${programId}/notifications/locations${params.size > 0 ? `?${params}` : ''}`,
    {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    })
    .then((response) => responseErrorHandler<Notification[]>(fetchContext.errorStore, response, 'get program notifications'));
};
